import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const geolocationState = atom<boolean>({
  key: 'geolocationState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});
